
import React, { Component } from "react";
import axios from "axios";

import AboutItem from "./AboutItem";

export class AboutBanners extends Component {
    state = {
        abouts: [],
        
    };
    
    componentDidMount() {
      axios
        .get("https://obrien365.com/ob-wp/wp-json/wp/v2/abouts?slug=about-obrien")
        .then((res) =>
        this.setState({
            abouts: res.data,
            
        })
        )
        .catch((err) => console.log(err));
    }
    
      render() {
        const { abouts } = this.state;
        
          return (
            <div className="App">

              
              {abouts.map((about) => (
                  //@ts-ignore
                <AboutItem key={about.id} about={about} />
              ))}
              
            </div>
          );
        }
      
}
export default AboutBanners;